import { useCallback } from 'react';
import { useStore } from 'reactflow';

const COLLAPSE_ZOOM_THRESHOLD = 0.2;

/**
 * Returns true when the canvas is zoomed out past the threshold,
 * signaling that nodes should collapse to header-only view.
 *
 * Uses useStore with a boolean selector so components only re-render
 * when the collapsed state actually flips, not on every zoom tick.
 */
export default function useZoomCollapse(threshold = COLLAPSE_ZOOM_THRESHOLD) {
  const selector = useCallback(
    (state) => state.transform[2] < threshold,
    [threshold]
  );
  return useStore(selector);
}
